import React, { useState } from "react";
import { Checkbox, FormControl, FormHelperText, InputLabel, ListItemIcon, ListItemText, MenuItem, Select, Tooltip } from "@mui/material";
import { Row, Col } from "react-bootstrap";
import { Info as InfoIcon } from '@mui/icons-material';
import PropTypes from 'prop-types';
import { useController, useForm, useFormContext } from 'react-hook-form';

const MenuProps = {
    anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
    },
    transformOrigin: {
        vertical: "top",
        horizontal: "center"
    },
    variant: "menu"
};

export default function MultiSelectInput(props) {

    const { errors, selectOptions, id, name, onChange, variant, helpText, inputColumnSize, value, renderLabelValue, ...textFieldProps } = props;
    const formContext = useFormContext();
    const fallbackForm = useForm();
    const { control } = formContext ?? fallbackForm;
    const {
        field,
        fieldState: { error },
    } = useController({
        name,
        control
    });
    const [focused, setFocused] = useState(false);

    const handleChange = (option) => {
        if (!option) field.onChange(null)
        else {
            field.onChange(option.target.value);
            onChange && onChange(option);
        }
    }

    const columnSize = inputColumnSize || 12;

    const menuItems = selectOptions && selectOptions.map((option, key) => {
        return <MenuItem className="p-0" key={key + 1} value={option.value} disabled={option.disabled}>
            <ListItemIcon className="me-n3">
                <Checkbox className="py-1 pe-4" checked={value.indexOf(option.value) > -1} color="primary" />
            </ListItemIcon>
            <ListItemText className="m-0" primary={option.label} />
        </MenuItem>
    });
    let commaSeparatedValue = value.join(", ");
    if (renderLabelValue) {
        commaSeparatedValue = selectOptions.filter(x => value.includes(x.value)).map(x => x.label).join(", ")
    }

    return (
        <Row>
            <Col xs={columnSize}>
                <FormControl fullWidth variant={variant || "filled"} error={!!error} focused={focused}>
                    <InputLabel htmlFor={id}>{props.label}</InputLabel>
                    <Select
                        multiple
                        value={value || []}
                        renderValue={() => commaSeparatedValue}
                        MenuProps={MenuProps}
                        onChange={handleChange}
                        onFocus={() => setFocused(true)}
                        onBlur={() => setFocused(false)}
                        onClose={() => setFocused(false)}
                        inputProps={{ id: id }}
                        {...textFieldProps}
                        fullWidth
                    >
                        {menuItems}
                    </Select>
                    <FormHelperText id={`${id}-helper-text`} aria-describedby={`${id}-helper-text`}>{error?.message}</FormHelperText>
                </FormControl>
            </Col>

            {helpText &&
                <Col xs={2}>
                    <div className="d-flex mt-2">
                        <Tooltip title={helpText}>
                            <InfoIcon color="action"></InfoIcon>
                        </Tooltip>
                    </div>
                </Col>
            }
        </Row>
    );
}

MultiSelectInput.propTypes = {
    id: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    selectOptions: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.any.isRequired,
        label: PropTypes.any.isRequired,
        disabled: PropTypes.bool,
    })).isRequired,
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    variant: PropTypes.string,
    errors: PropTypes.object,
    helpText: PropTypes.string
}
